// @ts-nocheck
/* eslint-disable */
import { icon, node } from "~/util/dom";
import { addListener } from "~/lib/signals";
import { CONFIG } from "~/config";
import Content from "~/content";
import { jsonParseCleaner } from "~/util/format";
import { _ } from "~/i18n";
import Scene from "~/scene";
import { isDetailActive } from "~/util/detail";
import { store } from "~/state/store";
import { ROUTE_CONST } from "~/route/const";
import { replaceOldCriterion, getPOI, paramTypeToSvg } from "~/route/utils";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";
import { description } from "./util/providers/poiagg";
import { standardDistanceFormat, standardTimeFormat } from "~/util/format";
import { isRouteReadOnly } from "./route/utils-common";
import { timeWithUserSpeed } from "~/util/user-speed";
import { getCriterion } from "~/util/route";
import createSDSIcon from "./ui/icon";
import { MYMAPS_CLOSE } from "./ui/sds-compatible-icons";

const LIMIT_ACCURACY = 5000;
let preparePUBTFlagsToURL = (flags?) => { return ""; };
let preparePUBTFlagsFromURL = (flags?) => { return ""; };

function convertOldParamsToNew(criterionInput) {
	let criterion = criterionInput;

	switch (criterion) {
		case "fast":
			criterion = 111;
			break;
		case "short":
			criterion = 113;
			break;
		case "bike1":
			criterion = 121;
			break;
		case "bike2":
			criterion = 122;
			break;
		case "bike3":
			criterion = 122;
			break;
		case "turist1":
			criterion = 131;
			break;
		case "turist2":
			criterion = 132;
			break;
		case "ski":
			criterion = 141;
			break;
		case "pubt":
			criterion = 200;
			break;
		case "water":
			criterion = 144;
			break;
		default:
			//
	}

	return criterion;
}

function checkDatetime(dateString: string): string {
	const inputDate = new Date(dateString);
	const now = new Date();

	if (inputDate >= new Date(now.getTime() - 24 * 60 * 60 * 1000)) {
		return dateString;
	} else {
		return "";
	}
}

/**
 * @class Routovací formulář
 */
Mapy.Route3 = class extends Content {
	constructor() {
		super();
		this._contentName = "route";
		this._route = null;
		this._loadPromise = null;
		this._dom = {
			container: node("div", { className: "route-container" }),
			overview: node("h4", { className: "bp-route" }),
		};
		this._contextItems = [
			{ cmi: new Mapy.Route.ContextItem(_("route.contextRouteFrom"), this, Mapy.Route.ContextItem.FROM), canBeDisabled: true },
			{ cmi: new Mapy.Route.ContextItem(_("route.contextRouteTo"), this, Mapy.Route.ContextItem.TO), canBeDisabled: true },
			{ cmi: new Mapy.Route.ContextItem(_("circuit.contextItem"), this, Mapy.Route.ContextItem.CIRCUIT), canBeDisabled: false },
		];

		this._ctrlCursor = null;
		this._ss = [];

		addListener(this, "distacemeter-activated", "_disableInteraction");
		addListener(this, "distacemeter-deactivated", "_enableInteraction");
		addListener(this, "usermarks-activated", "_disableInteraction");
		addListener(this, "usermarks-deactivated", "_enableInteraction");
		addListener(this, "print-page", "_printPage");
		addListener(this, "print-done", "_printDone");
		this._ss.push(Scene.addListener("geoloc-open", "_fillFromGeo", this));

		this._lids = [];
		this._lids.push(Mapy.CML.addListener(responseData => {
			if (responseData.length === 0) {
				this._dom.overview.remove();
			}
		}, "route.responseData"));
	}

	destroy() {
		Mapy.CML.removeListeners(this._lids);
		Scene.removeListeners(this._ss);
		super.destroy();
	}

	async activate() {
		if (!this._route) {
			await this._load();
		}

		if (this.isActive() && this._route && Mapy.getComponent("layout").getWidth() === 1) {
			this._route.setDefaultState();
			window.dispatchEvent(new CustomEvent("routeDefaultState"));
			Mapy.getComponent("history").save();
		}

		if (!Mapy.CML.state.route.items.length) {
			const state = store.getState();
			const { data: detailData, mark } = state.detail;

			if (isDetailActive(state) && mark) {
				Mapy.CML.state = {
					route: {
						params: {
							criterion: detailData.source === "pubt" ? 200 : 111,
							type: detailData.source === "pubt" ? ROUTE_CONST.TYPE_PUBT : ROUTE_CONST.TYPE_CAR,
						},
					},
				};

				this.addItem({
					coords: Scene.coordsFromWGS84(mark.lon, mark.lat),
					position: ROUTE_CONST.position.end,
					name: detailData.title,
					source: detailData.source,
					id: detailData.source === "coor" ? "" : parseFloat(detailData.id),
				});
			} else if (!Mapy.CML.state.route.noGEOPosition) {
				const pos = Mapy.getComponent("geolocation").getPosition();
				const accuracy = LIMIT_ACCURACY;

				if (pos.accuracy <= accuracy) {
					this.addItem();

					Mapy.CML.state = {
						route: {
							noGEOPosition: true,
						},
					};
				}
			}
		}

		document.addEventListener("keydown", this, false);
		document.addEventListener("keyup", this, false);
		Mapy.getComponent("stateswitch").setState(this);

		return super.activate();
	}

	deactivate() {
		document.removeEventListener("keydown", this, false);
		document.removeEventListener("keyup", this, false);
		this.hide();

		if (!Mapy.CML.state.route.items.length) {
			Mapy.CML.state = {
				route: {
					noGEOPosition: false,
				},
			};
		}

		return super.deactivate();
	}

	async clear(state) {
		if (!this._route) {
			await this._load();
		}

		this._route.setDefaultState(state);
	}

	show() {
		Mapy.getComponent("layout").getScrollNode().classList.add("route");

		const userIsPremium = store.getState().user.user?.premium;
		const routeState = Mapy.CML.state.route;

		Mapy.CML.state = {
			route: {
				active: true,
				userIsPremium,
				readOnly: isRouteReadOnly(userIsPremium, routeState.params || {}),
			},
		};

		if (routeState.responseData && routeState.responseData.length) {
			this._enableInteraction();
		}

		const show = () => {
			this._route.show();
			Mapy.getComponent("history").save();
		};

		if (this._route) {
			show();
		} else {
			this._load().then(() => {
				show();
			}, () => {});
		}

		return super.show();
	}

	hide() {
		Mapy.getComponent("layout").getScrollNode().classList.remove("route");

		const hide = () => {
			this._route.hide();
		};

		if (this._route) {
			hide();
		} else {
			this._load().then(() => {
				hide();
			}, () => {});
		}

		Mapy.CML.state = {
			route: {
				active: false,
			},
		};

		return super.hide();
	}

	setState(state) {
		const fromHistory = Mapy.getComponent("history").isFromHistory();

		this._load().then(() => {
			if (state.mrp && state.rc) {
				let params = {};

				try {
					if (state.mrp instanceof Array) {
						params = JSON.parse(state.mrp.filter(i => i.trim())[0] || "{}", jsonParseCleaner);
					} else {
						params = JSON.parse(state.mrp || "{}", jsonParseCleaner);
					}
				} catch (ex) {
					//
				}

				const coords = Scene.stringToCoords(state.rc);
				const ri = Array.isArray(state.ri) ? state.ri : [state.ri];
				const rfi = Array.isArray(state.rfi) ? state.rfi : [state.rfi];
				const rs = Array.isArray(state.rs) ? state.rs : [state.rs];
				let ci = 0;
				const items = [];

				for (let i = 0, max = Math.min(ri.length, rs.length); i < max; i++) {
					const source = rs[i] || "";
					let id = "";
					const coord = coords[ci];

					if (rs[i] === "coor" || (rs[i] === "" && rs.length === coords.length)) {
						id = coord ? coord.toWGS84().join(",") : "";
					} else {
						id = parseFloat(ri[i]) || 0;
					}

					if (!coord || !id || (source === "" && !id)) {
						continue;
					}

					const title = Mapy.getComponent("gps").coordsToFormat(coord);
					const newItem = {
						id,
						source,
						geometry: Scene.coordsToString([coord]),
						title,
						desc: title,
						...rfi[ci] ? { favoriteId: rfi[ci] } : {},
					};

					// pokud jsou jen dva bod a zarove prvni neni vyplneny, nasatvime item jako cil
					if (i === max - 1 || (rs.length === 2 && rs[0] === "" && ri[0] === "" && coords.length === 1)) {
						// konec
						newItem.position = 2;
					}

					items.push(newItem);
					ci++;
				}

				let promise = Promise.resolve();

				if ((typeof params.c).toLowerCase() === "string") {
					params.c = convertOldParamsToNew(params.c);
				} else if (params.c < 100) {
					params.c = replaceOldCriterion(params.c, params.toll);
				}

				// nacteme description pro 1-n polozek co neni coor
				// dame timeout, kdyby to trvalo moc dlouho
				if (items.length) {
					// timeout pro nacteni
					const descTimeout = items.length === 1 ? 700 : 350;

					// stahneme si desc
					promise = new Promise(resolve => {
						let canceled = false;
						let poiData = {};
						let poiMapping = {};

						items.forEach(i => {
							if (i.source == "coor") {
								return;
							}

							const id = `${i.source}_${i.id}`;

							poiMapping[id] = i;
							if (!(i.source in poiData)) {
								poiData[i.source] = [];
							}
							poiData[i.source].push(i.id);
						});

						let toID = setTimeout(() => {
							toID = null;
							canceled = true;
							resolve();
						}, descTimeout);

						const faouriteDataPromise = this._getFavouriteData(items);

						const descriptionPromise = description(items, {
							fetchPhoto: true,
							ratios: ["3x2"],
							lang: CONFIG.langPriority,
							wikimedia: true,
						}).then(r => {
							if (canceled) {
								return;
							}

							clearTimeout(toID);
							toID = null;
							r.poi.forEach(i => {
								const id = `${i.source}_${i.id}`;

								if (id in poiMapping) {
									Object.assign(poiMapping[id], {
										images: i.media ? i.media.urls : null,
										title: i.title,
										desc: i.multiTitle ? i.multiTitle.filter((i, ind) => i.trim() && ind > 0).join(", ") : (i.desc || i.description || ""),
									});
								}
							});
						}, () => {});

						Promise.allSettled([descriptionPromise, faouriteDataPromise]).then(() => {
							if (canceled) {
								return;
							}

							resolve();
						});
					});
				}

				let tripIndex = 0;
				let tripCriterion = ROUTE_CONST.circuitTypes.trial.def;
				let tripWaypoints = "";

				let rt = state.rt && Array.isArray(state.rt) ? state.rt[0] : state.rt;

				if (rt && rt !== "") {
					try {
						let tripParams = JSON.parse(rt);
						let criterion = parseInt(tripParams.t) > 100 ? tripParams.t : replaceOldCriterion(tripParams.t);

						tripIndex = tripParams.ti || 0;
						tripCriterion = criterion || ROUTE_CONST.circuitTypes.trial.def;
						tripWaypoints = tripParams.twp || "";
						items[0].planTrip = true;
					} catch (ex) {
						//
					}
				}

				let type = ROUTE_CONST.TYPE_CAR;
				const keys = Object.keys(ROUTE_CONST.types);

				keys.forEach(k => {
					let t = ROUTE_CONST.types[k];
					const cr = items[0] && items[0].planTrip ? tripCriterion : params.c;

					if (t.criterion.indexOf(cr) > -1) {
						type = t.type;
					}
				});

				if ((fromHistory && !state.x) || CONFIG.inFrame) {
					Mapy.CML.state = {
						route: {
							zoom: true,
							forceZoom: true,
						},
					};
				}

				promise.then(() => {
					const routeBooleanFlags = (state.rbf || "").split(",");

					let p = {
						criterion: params.c,
						excludeCountries: state.xc ? JSON.parse(state.xc) : [],
						useTraffic: "rut" in state && state.rut === "1" && [111, 112].indexOf(params.c) > -1,
						departure: "d" in params ? params.d : true,
						datetime: params.dt ? checkDatetime(params.dt) : "",
						tripIndex,
						tripCriterion,
						type,
						waypoints: tripWaypoints,
						pubtIndex: params.i ? params.i : null,
						flags: preparePUBTFlagsFromURL(params.f || ""),
						avoidHighways: routeBooleanFlags.includes("ah"),
						allowViaFerrata: routeBooleanFlags.includes("avf"),
					};

					if ("cs" in params) {
						p.criterionSpecs = params.cs;
					}

					Mapy.CML.state = {
						route: {
							fromHistory,
							params: p,
							routeWaypoints: state.rwp,
							items,
							alternatives: !state.rwp,
						},
					}
				}, () => {});
			} else if (state.rc && state.rl) {
				this._convertOldUrl(state);
			}
		}, () => {});
	}

	// eslint-disable-next-line class-methods-use-this
	getState() {
		const routeState = Mapy.CML.state.route;
		const state = {};

		if (routeState.items.length && (!routeState.likeData || (routeState.likeData && routeState.likeDataChange))) {
			let ids = [];
			let sources = [];
			let coords = [];
			let favoriteIds = [];
			let rt = [];

			if (routeState.items.length === 1 && !routeState.items[0].planTrip && routeState.items[0].position === 2) { // pokud mame jeden item, ale je to cil
				ids.push("");
				sources.push("");
			}

			routeState.items.forEach((i, ind) => {
				if (i.source === "coor") {
					ids.push("");
				} else {
					ids.push(i.id);
				}

				favoriteIds.push(i.favoriteId || "");

				sources.push(i.source);
				coords.push(Scene.stringToCoords(i.geometry)[0]);
				// vylety
				if (!ind && i.planTrip) {
					const tripParams = {
						t: routeState.params.tripCriterion,
					};

					if (routeState.params.waypoints) {
						tripParams.twp = routeState.params.waypoints;
					} else {
						tripParams.ti = routeState.params.tripIndex;
					}
					rt.push(JSON.stringify(tripParams));
					rt.push("");
				}
			});
			if (sources.length < 2) {
				sources.push("");
			}
			if (ids.length < 2) {
				ids.push("");
			}

			const mrp = {
				c: routeState.params.criterion,
			};

			if ("datetime" in routeState.params && (Mapy.CUS?.route?.datetimeForAll || mrp.c === ROUTE_CONST.types.pubt.def)) {
				mrp.dt = routeState.params.datetime;
			}

			if ("departure" in routeState.params && (Mapy.CUS?.route?.datetimeForAll || mrp.c === ROUTE_CONST.types.pubt.def)) {
				mrp.d = routeState.params.departure;
			}

			if (mrp.c === ROUTE_CONST.types.pubt.def) {
				mrp.d = routeState.params.departure;

				if (routeState.params.pubtIndex) {
					mrp.i = routeState.params.pubtIndex;
				}
				if (routeState.params.criterionSpecs && Object.keys(routeState.params.criterionSpecs).length) {
					mrp.cs = routeState.params.criterionSpecs;
				}

				if (Mapy.CUS.userweb.routeNewHD) {
					const preference = preparePUBTFlagsToURL(routeState.params.flags);
					if (preference.length) {
						mrp.f = preference.join(",");
					}
				}
			}

			state.rc = Scene.coordsToString(coords);
			state.rs = sources;
			state.ri = ids;

			if (favoriteIds.filter(favoriteId => favoriteId !== "").length) {
				state.rfi = favoriteIds;
			}

			state.mrp = JSON.stringify(mrp);
			state.rt = rt;
			state.xc = JSON.stringify(routeState.params.excludeCountries || []);

			if (routeState.responseData[routeState.index] && routeState.responseData[routeState.index].routeWaypoints !== "") {
				state.rwp = routeState.responseData[routeState.index].routeWaypoints;
			}

			if (routeState.params.useTraffic && !state.rt.length) {
				state.rut = "1";
			}

			const routeBooleanFlags = [];

			if (routeState.params.avoidHighways) {
				routeBooleanFlags.push("ah");
			}

			if (routeState.params.allowViaFerrata) {
				routeBooleanFlags.push("avf");
			}

			if (routeBooleanFlags.length) {
				state.rbf = routeBooleanFlags.join(",");
			}
		}

		return state;
	}

	getRouteOverview(addRemoveBtn) {
		const routeState = Mapy.CML.state.route;

		if (routeState.responseData?.length) {
			const el = this._dom.overview;

			el.innerHTML = _("route.title", {
				LEN: standardDistanceFormat(routeState.responseData[routeState.index]?.totalLength || 0).string,
				TIME: standardTimeFormat(timeWithUserSpeed(routeState.responseData[routeState.index]?.totalTime || 0, getCriterion())).string,
			});
			if (addRemoveBtn) {
				const btn = node("button", { className: "clear-btn edit-props-btn" });

				btn.appendChild(createSDSIcon({ className: "edit-props-btn-icon-exit", symbol: MYMAPS_CLOSE }));
				btn.addEventListener("click", async e => {
					await this.clear();
					el.remove();
					if (Mapy.getComponent("search").isActive()) {
						Mapy.CML.state = {
							route: {
								interaction: false,
							},
						};
					}
				});
				el.appendChild(btn);
			}

			return el;
		}

		return null;
	}

	async routeFromRawData(data, routeParams) {
		let likeData = null;
		const params = {};
		const items = [];
		let routeWaypoints = "";
		let routeData = [];

		await this.clear();

		if ("likeData" in data) {
			likeData = data.likeData;
			routeData = likeData.data.route;
		}

		for (let i = 0; i < routeData.length; i++) {
			if ("routeParams" in routeData[i] && "criterion" in routeData[i].routeParams && (routeData[i].routeParams.criterion < 100 || routeData[i].routeParams.criterion == "pubt")) {
				routeData[i].routeParams.criterion = replaceOldCriterion(routeData[i].routeParams.criterion, routeData[i].routeParams.toll);
				delete routeData[i].routeParams.toll;
			}

			if (i === 0) {
				params.criterion = "routeParams" in routeData[i] ? routeData[i].routeParams.criterion : ROUTE_CONST.types.car.criterion[0];

				if ("tripParams" in routeData[i]) {
					params.tripIndex = routeData[i].tripParams.tripIndex;
					params.tripCriterion = routeData[i].tripParams.criterion;

					if ("waypoints" in routeData[i].tripParams) {
						params.waypoints = routeData[i].tripParams.waypoints;
					}
				}

				params.departure = "departure" in routeData[i].routeParams ? routeData[i].routeParams.departure : true;
				params.datetime = "datetime" in routeData[i].routeParams ? checkDatetime(routeData[i].routeParams.datetime) : "";
			}

			if (routeData[i].source && routeData[i].source === "coor" && !routeData[i].id) {
				routeData[i].id = "";
			}

			items.push(routeData[i]);
		}

		if (items.length === 1 && params.tripCriterion) {
			items[0].planTrip = true;
		}

		if (routeParams && "tollExcludeCountries" in routeParams) {
			params.excludeCountries = routeParams.tollExcludeCountries;
		}

		if (routeParams && "routeWaypoints" in routeParams) {
			routeWaypoints = routeParams.routeWaypoints;
		}

		params.useTraffic = routeParams && "useTraffic" in routeParams ? routeParams.useTraffic : false;
		params.avoidHighways = routeParams && "avoidHighways" in routeParams ? routeParams.avoidHighways : false;
		params.allowViaFerrata = routeParams && "allowViaFerrata" in routeParams ? routeParams.allowViaFerrata : false;

		const keys = Object.keys(ROUTE_CONST.types);

		keys.forEach(k => {
			let t = ROUTE_CONST.types[k];

			if (t.criterion.indexOf(params.criterion) > -1) {
				params.type = t.type;
			}
		});

		// napojeni na zmenu parametru a request
		return new Promise((resolve, reject) => {
			let isRequest = false;
			let id = Mapy.CML.addListener((loading, state) => {
				if (loading) {
					isRequest = true;
				}
				else if (!loading && isRequest) {
					Mapy.CML.removeListenerId(id);

					Mapy.CML.state = {
						route: {
							fromRawData: false,
						},
					};

					if (state.route.error) {
						reject();
					}
					else {
						resolve();
					}
				}
			}, "route.loading");

			Mapy.CML.state = {
				route: {
					likeData,
					likeDataChange: false,
					fromRawData: true,
					items,
					params,
					routeWaypoints,
					alternatives: false,
					zoom: true,
					showLabelInFrame: data.showLabel || 0,
				},
			};
		});
	}

	/*
		metodu vola ten, kdo sestavuje kontextovou nabidku
	*/
	// eslint-disable-next-line class-methods-use-this
	forceZoom() {
		Mapy.CML.state = {
			route: {
				forceZoom: true,
			},
		};
	}

	getContextItems() {
		const state = Mapy.CML.state;
		const isReadOnly = state.route.readOnly;

		return this._contextItems.filter(item => !isReadOnly || (isReadOnly && !item.canBeDisabled)).map(item => item.cmi);
	}

	mapClick(e) {
		const curState = Mapy.CML.state.route;

		if (curState.readOnly) {
			return;
		}

		if (!this._distanceMeterIsActive && (e.ctrlKey || e.metaKey || e.keyCode == 17 || e.keyCode == 91)) {
			let coords = Scene.coordsFromEvent(e);

			Mapy.CML.state = {
				route: {
					loading: true,
				},
			};

			getPOI(coords).then(data => {
				let items = Mapy.CML.state.route.items;
				items.push(data);
				Mapy.CML.state = {
					route: {
						items,
						scroll: true,
						zoom: false,
						loading: false,
					},
				};
				Mapy.getComponent("history").save();
			}, () => {});

			return true;
		}
	};

	m3dClick(e, coords) {
		const routeState = Mapy.CML.state.route;

		if (Mapy.getComponent("userMarks").isActive() || Mapy.getComponent("distanceMeter").isActive() || routeState.readOnly) return;

		let len = routeState.items.length;

		// vylet ve 3d - nechceme pridavat dalsi body
		if (len === 1 && routeState.items[0].planTrip) {
			return;
		}

		if (len < 2 || (e.ctrlKey || e.metaKey || e.keyCode === 17 || e.keyCode === 91)) {
			getPOI(coords).then(data => {
				const items = Mapy.CML.state.route.items;

				items.push(data);
				Mapy.CML.state = {
					route: {
						items,
						scroll: true,
					},
				};
				Mapy.getComponent("history").save();
			}, () => {});
		}
	}

	readOnlyError() {
		Notifications.notify({
			content: _("route.readOnlyError"),
			type: NOTIFICATIONS_TYPE.ERROR,
		});
	}

	// pro mobilni verzi nastavit titulek do panelu
	setBottomPanel() {
		let routeState = Mapy.CML.state.route;
		let len = routeState.items.length;

		if (len > 0) {
			let way = "seoTo";
			if (len == 1) {
				way = "seoFrom";
			}

			Mapy.getComponent("layout").setBottomPanel(node("h4", {
				className: "bp-route",
				innerHTML: _("route." + way, routeState.items[0].title),
			}));
		}
	}

	// toHistory, jen v pripade itemu z fixniho naseptavace
	// eslint-disable-next-line class-methods-use-this
	async addItem(data, addToHistory) {
		const items = Mapy.CML.state.route?.items || [];

		if (!this._route) {
			await this._load();
		}

		const addGeolocationToItems = () => {
			const pos = Mapy.getComponent("geolocation").getPosition();
			const accuracy = LIMIT_ACCURACY;

			if (pos.accuracy <= accuracy) {
				if (data) {
					data.position = ROUTE_CONST.position.end;
				}
				let title = Mapy.getComponent("gps").coordsToFormat(pos.coords);

				items.push({
					geometry: Scene.coordsToString([pos.coords]),
					source: "coor",
					id: pos.coords.toWGS84().join(", "),
					title,
					desc: title,
					position: ROUTE_CONST.position.start,
				});
			}
		}

		if (!data) {
			addGeolocationToItems();

			Mapy.CML.state = {
				route: {
					items,
				},
			}

			return;
		}

		if (items.length === 0 && !data.planTrip) {
			addGeolocationToItems();
		}

		if (!data.coords && data.mark) {
			data.coords = Scene.coordsFromWGS84(data.mark.lon, data.mark.lat);
		}

		let newItem = {
			id: data.id,
			source: data.source,
			geometry: Scene.coordsToString([data.coords]),
			title: data.title,
			usertitle: data.usertitle || "",
			favoriteId: data.favoriteId || "",
			..."typeId" in data ? { typeId : data.typeId } : {},
			...data.name ? { title: data.name } : {},
			...data.position ? { position: data.position } : {},
			...data.desc ? { desc: data.desc } : {},
		};

		if (data.source === "coor") {
			let title = Mapy.getComponent("gps").coordsToFormat(data.coords);
			if (!data.favoriteId) {
				newItem.title = title;
			}
			newItem.desc = title;
		}

		items.push(newItem);

		if (addToHistory) {
			const toHistory = Mapy.CML.state.route.toHistory;

			if (newItem.source === "coor") {
				toHistory.push({
					title: newItem.usertitle || newItem.title,
					source: "web",
					type: "query",
				});
			} else {
				toHistory.push({
					title: newItem.usertitle || newItem.title,
					source: "web",
					type: "poi",
					data: {
						entityId: newItem.id,
						entitySource: newItem.source,
						lon: data.coords.x,
						lat: data.coords.y,
					},
				});
			}

			Mapy.CML.state = {
				route: {
					toHistory,
					items,
				},
			};
		} else {
			Mapy.CML.state = {
				route: {
					items,
				},
			};
		}
	}

	// eslint-disable-next-line class-methods-use-this
	preventZoom() {
		Mapy.CML.state = {
			route: {
				zoom: false,
			},
		};
	}

	// eslint-disable-next-line class-methods-use-this
	resetZoom() {
		Mapy.CML.state = {
			route: {
				zoom: true,
			},
		};
	}

	// eslint-disable-next-line class-methods-use-this
	getPubtBoost() {
		const routeState = Mapy.CML.state.route;

		return routeState.params.type === ROUTE_CONST.TYPE_PUBT;
	}

	handleEvent(e) {
		if (e.ctrlKey || e.metaKey || e.keyCode === 17 || e.keyCode === 91 || e.keyCode === 92 || e.keyCode === 93 || e.keyCode === 224) { // control + meta na jabkach
			if (e.type === "keydown") {
				if (!this._ctrlCursor) {
					this._ctrlCursor = Mapy.Cursor.add({ cursor: "crosshair" });
				}
			} else if (this._ctrlCursor) {
				Mapy.Cursor.remove(this._ctrlCursor);
				this._ctrlCursor = null;
			}
		}
	}

	createOGContent(totalLength, totalTime) {
		this._dom.container.remove();

		const ogContent = node("div", { className: "og-content" });
		const iconElm = icon(paramTypeToSvg(Mapy.CML.state.route));
		const distance = node("strong", { className: "distance", textContent: standardDistanceFormat(totalLength).string });
		const forSpan = node("span", { className: "for", textContent: _("route.ogContent") });
		const time = node("strong", { className: "time", textContent: standardTimeFormat(totalTime).string });
		const overlay = node("div", { className: "bottom-overlay" });

		ogContent.appendChild(iconElm);
		ogContent.appendChild(distance);
		ogContent.appendChild(forSpan);
		ogContent.appendChild(time);

		overlay.appendChild(ogContent);
	}

	_printPage() {
		if (!this.isActive()) {
			return;
		}

		Mapy.CML.state = {
			route: {
				print: true,
			},
		};
	}

	_printDone() {
		if (!this.isActive()) {
			return;
		}

		Mapy.CML.state = {
			route: {
				print: false,
			},
		};
	}

	// eslint-disable-next-line class-methods-use-this
	_disableInteraction() {
		Mapy.CML.state = {
			route: {
				interaction: false,
			},
		};
	}

	_enableInteraction() {
		if (this.isActive()) {
			Mapy.CML.state = {
				route: {
					interaction: true,
				},
			};
		}
	}

	_getFavouriteData(items) {
		let promises = [Promise.resolve()];

		items.forEach(item => {
			if (item.favoriteId) {
				promises.push(Mapy.ProviderMapyBox.likeDetail(item.favoriteId).then(response => {
					if (response.status === 200 && response.like?.usertitle) {
						item.usertitle = response.like.usertitle;
					}
				}));
			}
		});

		return Promise.allSettled(promises);
	}

	_fillFromGeo(e) {
		if (!this.isActive()) {
			return;
		}

		const geo = e.target.getPosition();

		if (geo.accuracy >= LIMIT_ACCURACY) {
			return;
		}

		const routeState = Mapy.CML.state.route;

		if (!routeState.items.length && !routeState.noGEOPosition) {
			const newItem = {
				geometry: Scene.coordsToString([geo.coords]),
				title: geo.coords.toWGS84(2).reverse().join(", "),
				source: "coor",
			};

			newItem.id = newItem.title;
			newItem.desc = newItem.title;
			routeState.items.push(newItem);

			Mapy.CML.state = {
				route: {
					items: routeState.items,
					noGEOPosition: true,
				},
			};
		}
	}

	_convertOldUrl(state) {
		let coords = Scene.stringToCoords(state.rc);
		let rl = (typeof state.rl).toLowerCase() == "string" ? [state.rl] : state.rl;

		if (coords.length) {
			let cIndex = 0;
			const items = [];

			if (coords.length === 1) {
				items.push({
					geometry: Scene.coordsToString([coords[cIndex]]),
					position: rl[0] === "" ? ROUTE_CONST.position.end : ROUTE_CONST.position.start,
					source: "coor",
					id: "",
				});
			} else if (rl.length >= coords.length) {
				for (let i = 0; i < rl.length; i++) {
					if (rl[i] !== "") {
						items.push({
							geometry: Scene.coordsToString([coords[cIndex]]),
							source: "coor",
							id: "",
						});
						cIndex++;
					}
				}
			} else {
				for (let i = 0; i < coords.length; i++) {
					items.push({
						geometry: Scene.coordsToString([coords[i]]),
						source: "coor",
						id: "",
					});
				}
			}

			const newRouteState = {
				route: {
					items,
				},
			};

			if (state.rp) {
				const rp = JSON.parse(state.rp);
				const criterion = convertOldParamsToNew(rp.criterion);

				newRouteState.route.params = {
					criterion,
					useTraffic: ROUTE_CONST.types.car.criterion.indexOf(criterion) !== -1,
				};
			}

			Mapy.CML.state = newRouteState;
		}

		Mapy.getComponent("history").save(true);
		!CONFIG.isScreenshoter && Mapy.setPhantomMeta(`301; ${window.location}`);
	}

	_load() {
		if (!this._loadPromise) {
			Mapy.getComponent("loader").start(true);
			const loaderBigCont = Mapy.getComponent("loader").getBigCon();
			const buttonRoute = Mapy.getComponent("layout").getBar().querySelector("button.route");
			buttonRoute.appendChild(loaderBigCont);
			if (Mapy.CUS.userweb.routeNewHD) {
				this._dom.container.classList.add("route4");
				this._loadPromise = import(
					/* webpackChunkName: "route4" */
					'~/route4/main.ts'
				);
			} else {
				this._loadPromise = import(
					/* webpackChunkName: "route" */
					'~/route/main.ts'
				);
			}
			this._loadPromise.then((module) => {
				module.initModule({ store, CONFIG, Scene, _, Notifications });

				if (Mapy.CUS.userweb.routeNewHD) {
					preparePUBTFlagsToURL = module.preparePUBTFlagsToURL;
					preparePUBTFlagsFromURL = module.preparePUBTFlagsFromURL;
				}

				this._route = new module.default(this._dom.container);
			}, () => {}).finally(() => {
				if (loaderBigCont.parentNode === buttonRoute) {
					loaderBigCont.remove()
				}
				Mapy.getComponent("loader").end(true);
			});
		}

		return this._loadPromise;
	}
};
